export default {
    'ERROR-SEND-LOGIN-ADMIN-SAAS': {
        'USER-NOT-FOUND': {
            actionType: '',
            message: {
                fr: "Utilisateur non trouvé.",
                en: 'User not found.',
            },
        },
        'USER-NOT-ADMIN-NOT-SUPER-ADMIN': {
            actionType: '',
            message: {
                fr: "L'utilisateur n'est ni administrateur, ni super administrateur.",
                en: 'User is neither admin nor super admin.',
            },
        },
        'ORGANIZATION-NOT-FOUND': {
            actionType: '',
            message: {
                fr: "Organisation non trouvée.",
                en: 'Organization not found.',
            },
        },
    },
    'ERROR-JWT-TOKEN-ADMIN': {
        'USER-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Utilisateur introuvable.",
                en: 'User not found.',
            },
        },
        'USER-ARCHIVED': {
            actionType: 'redirect',
            message: {
                fr: "Ce compte a été archivé.",
                en: 'This account has been archived.',
            },
            redirectPath: '/login',
        },
        'USER-NOT-ADMIN-OR-SUPER-ADMIN': {
            actionType: 'redirect',
            message: {
                fr: "Vous n'avez pas les droits nécessaires. Veuillez contacter l'administrateur.",
                en: 'You do not have the required rights. Please contact the administrator.',
            },
            redirectPath: '/login',
        },
        'USER-NOT-TEAMSPACE-ADMIN': {
            actionType: 'redirect',
            message: {
                fr: "Aucun espace d'équipe administré n'a été trouvé. Veuillez contacter l'administrateur.",
                en: 'No admin teamspace found for this user. Please contact the administrator.',
            },
            redirectPath: '/login',
        },
        'USER-NOT-ADMIN-NOT-SUPER-ADMIN': {
            actionType: 'redirect',
            message: {
                fr: "Vous n'avez pas les droits nécessaires. Veuillez contacter l'administrateur.",
                en: 'You do not have the required rights. Please contact the administrator.',
            },
            redirectPath: '/login',
        },
    },
};
